var classof = require('../internals/classof-raw');
var global = require('../internals/global');

module.exports = classof(global.process) == 'process';



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/engine-is-node.js